import React, { useEffect } from 'react';

const EmbeddedCookieConsent: React.FC = () => {
  useEffect(() => {
    let oneTrustObj = window.OneTrust;

    const initConsentChangedListener = () => {
      oneTrustObj?.OnConsentChanged?.(() => {
        if (oneTrustObj?.IsAlertBoxClosed()) window.close();
      });
    };

    const setPCStyles = () => {
      const container = document.getElementById('onetrust-consent-sdk') as HTMLElement;
      const banner = document.getElementById('onetrust-banner-sdk') as HTMLElement;
      const pref = document.getElementById('onetrust-pc-sdk') as HTMLElement;
      const prefCloseBtn = document.getElementById('close-pc-btn-handler') as HTMLElement;

      container.style.fontFamily =
        "Roboto, -apple-system, 'system-ui', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif";
      prefCloseBtn.setAttribute('style', 'display: none !important;');
      if (
        banner &&
        (oneTrustObj?.IsAlertBoxClosed() === false || pref.className.includes('ot-hide'))
      ) {
        banner.innerHTML = '<div/>';
      }
    };

    Object.defineProperties(window, {
      OneTrust: {
        get: () => oneTrustObj,
        set: (value) => {
          oneTrustObj = value;
          initConsentChangedListener();
        }
      }
    });

    window.addEventListener('OneTrustPCLoaded', setPCStyles);
    initConsentChangedListener();

    return () => {
      window.removeEventListener('OneTrustPCLoaded', setPCStyles);
    };
  }, []);

  return <div />;
};

export default EmbeddedCookieConsent;
